module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/projector-icon-603ef5e734f9af8f9808917027c01955.png";